export enum Rol {
  USUARIO_LIBRE = '1',
  AGLUTINADORA = '2',
  ASEGURADORA = '3',
  DGRN = '4',
  PRODUCTOR = '5',
  DGRN_JEFE = '6',
}
